import { render } from "./ProductAddedOverlay.vue?vue&type=template&id=002eb74d"
import script from "./ProductAddedOverlay.vue?vue&type=script&lang=js"
export * from "./ProductAddedOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__